import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik } from "formik"; import Menubar from "../Menubar"; import { store } from "../../App"; 
 import MasterService from "../../Services/MasterService";
import { AiFillFileExcel,  } from "react-icons/ai"; import { IoReturnDownForward } from "react-icons/io5";

import { Container, Row, Col, Nav ,Button} from 'react-bootstrap'; 
// import { RiUserFollowLine } from "react-icons/ri"; import {  IoIosReturnLeft } from "react-icons/io";
import { MdOutlinePictureAsPdf } from "react-icons/md"; import { FaRegSave, FaExclamationTriangle } from "react-icons/fa";
import "jspdf-autotable"; import KpiService from "../../Services/KpiService"; import {  exportToentryExcel,  generateentryPdf, getCurrentFinancialYear, isValidsix} from "../utils/commonFunctions"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert"; import { Alert } from "@mui/material";

export default function NewIndcentry() {
  const financialYear = getCurrentFinancialYear();const[showModal,setshowModal] = useState(false); const [distEnb, setDistEnb] = useState(false); const [Mandalenb, setMandalenb] = useState(false); const [distlist, setDistrictList] = useState(); const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [Categorylist, setCategorylist] = useState(); const [workFlow, setworkFlow] = useState([]); const [currentstatus, setCurrentstatus] = useState(""); const [mandallist, setMandalList] = useState(); const [Yearlist, setYearlist] = useState(); const [Id, setId] = useState() ;const [Periodicid, setperiodicId] = useState(); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [sequenceId, setSequenceid] = useState(); const [Roleeid, setRoleeid] = useState() ;const [addModal, setAddModal] = useState();  const [mandalId, setmandalId] = useState(); const [distId, setDistId] = useState(); const [searchText, setSearch] = useState(""); const [CpoTableenb, setCpoTableenb] = useState(false); const [Cpodata, setCpodata] = useState([]); const [MandalCpo, setMandalCpo] = useState(); const [Year, setYear] = useState(); const [HeadId, setHeadId] = useState(); const [fieldenb, setfieldenb] = useState(false); const [statusId, setstatusId] = useState();
 let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid"); let deptId = localStorage.getItem("deptid"); let username = localStorage.getItem("username"); let roleid = localStorage.getItem("role"); let deptName = localStorage.getItem("deptName"); let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");  let ulbcode = localStorage.getItem("ulbid");let ulbname = localStorage.getItem("ulbname");
const[newindcenb,setNewincenb]=useState();
const[Newindbutton,setNewindbutton]=useState();
const formik = useFormik({ initialValues: { userId: "", district_id: "", department_id:"", mandal_id: "", 
    periodic_id:"", ind_type:"",category:"", year:"", date:"",
     Indicators: [{ mer_sector_id: "", unit: "" ,mer_sector_ind_value:"",status_id:"",mer_sector_ind_id:"",}], remarks:"" }, })
  // const handleClose = () => { setAddModal(false); }
  // const handleClosepop = () => { setshowModal(false); }
  React.useEffect(() => {
    if ((roleid === "31") || (roleid === "3") || (roleid === "10")) { setDistEnb(true); setMandalenb(true) }
    if (roleid === "60" ||roleid === "5") { setDistEnb(false) }
    if (roleid === "32"||roleid === "2") { setMandalenb(false); setDistEnb(true); }
    formik.setFieldValue("district_id", district !== "0" ? district : "");
    let params = { "district_id": district }
    MasterService.getMandals(params).then((res) => { if (res.data) { let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setMandalList(options); } });
    formik.setFieldValue("mandal_id", mandal !== "0" && mandal !== "00" ? mandal : ""); }, [])
const Emptyfields=()=>{  formik.setFieldValue("periodic_id",""); formik.setFieldValue("year",""); formik.setFieldValue("category",""); }
  const handleKeyDown = (e) => { if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); } };const [Deptlist, setDeptlist] = useState([]); const [data, setData] = useState(null);
    const periodicityMap = {  monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" } };
  const[syn,setSynteticevent]=useState();
//   useEffect(() => {  { const firstKey = Object.entries(periodicityMap).find(([key]) => data?.[key] > 0); if (firstKey) { const { value } = firstKey[1]; setActivePeriodicity(value); const syntheticEvent = { target: { name: 'periodic_id', value }, }; YearData(syntheticEvent); setSynteticevent(syntheticEvent); formik.handleChange(syntheticEvent); } } }, [data]);
useEffect(() => {
  const value = "6"; // Monthly default
  setActivePeriodicity(value);
  const syntheticEvent = { target: { name: "periodic_id", value } };
  YearData(syntheticEvent);
  setSynteticevent(syntheticEvent);
  formik.handleChange(syntheticEvent);

}, []);
  useEffect(() => {
  store.dispatch({ type: "SHOW_SPINNER" });
  if(roleid!=="8"){
  }
MasterService.getDistricts().then((res17) => { if (res17.data) { let options = res17.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setDistrictList(options); } });
    if(roleid === "8"){ let paramss={ userId:username }; MasterService.getDeptartments(paramss).then((res) => { if (res.data) { let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.dept_id}> {item.dept_name} </option> ); }); setDeptlist(options); } }); }
store.dispatch({ type: "HIDE_SPINNER" }); }, []);
  useEffect(() => { const handleScroll = () => { ReactTooltip.hide(); }; window.addEventListener("scroll", handleScroll); return () => { window.removeEventListener("scroll", handleScroll); }; }, []);

const[activePeriodicity,setActivePeriodicity]=useState("6")
   


const YearData=(e)=>{
  formik.setFieldValue("year",""); formik.setFieldValue("date",""); formik.setFieldValue("category",""); setEntrydataEnb(false); setCpoTableenb(false);
  if(!e.target.value ){return;} setperiodicId(e.target.value) ;setId("");
  let params={ userId:username, periodicityId:e.target.value||activePeriodicity }
  KpiService.KpiperiodicYears(params).then((res20) => {
    let years = res20.data?.SDESC?.yearsList || [];
   let res = years.slice(0, -1);
    if (res20.data) { let options = res.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setYearlist(options); }
  }); setYearlist([]); setEntrydataEnb(false) }
const Categorydata = (e) => {
  setEntrydataEnb(false);
  setCategorylist([]); formik.setFieldValue("category",""); formik.setFieldValue("date","");
  if (!e.target.value) {
    let missingFields = [];
    if(roleid === "8"){ if(!formik.values.district_id) missingFields.push("District"); if(!formik.values.mandal_id) missingFields.push("Mandal") }
      if(formik.values.periodic_id ) missingFields.push("Periodicity"); if (!e.target.value) missingFields.push("Year");
    const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`; showAlertMessage(errorMessage, "warning"); setEntrydataEnb(false); setCpoTableenb(false); return; }
  const selectedYear = e.target.value; setId(selectedYear);
  if (["1", "2", "3","8"].includes(Periodicid)) {
    if(!["31","3","8"].includes(roleid)){ let paramss={ "userId":username, "districtId":roleid==="60" || (roleid === "5") ?distId:district, "periodicityId":formik.values.periodic_id||syn?.target?.value, "year":e.target.value, "deptId" : roleid === "8" ? formik.values.department_id : deptId , "headId":"0" }; CountData(paramss); }
    else{
         const params = { userId: username, 
            districtId: district,
            mandalId:ulbdeptlist.includes(deptId)?"0": mandal,ulbId:ulbdeptlist.includes(deptId)? ulbcode: "0",
             year: e.target.value, 
             headId: "0",
              deptId: roleid === "8" ? formik.values.department_id : deptId,
               periodicityId: formik.values.periodic_id||syn?.target?.value, };
                fetchEntryData(params,selectedYear); }
  }
   else { const params = { userId: username, periodicityId: Periodicid,year:e.target.value }; KpiService.kpiperiodicityMasterFutureDatesExtension(params).then((res) => { const response = res.data.SDESC.headList; const options = response.map((item, i) => ( <option key={i} value={item.id}> {item.value} </option> )); setCategorylist(options); }); }};

const CountData=(params)=>{
   store.dispatch({ type: "SHOW_SPINNER" });
  KpiService.CpoTableData(params).then((res) => {
    if(res.data.SCODE==="02"){ showAlertMessage(res.data.SDESC,"warning") }
  if(res.data.SCODE==="01"){
  setCpodata(res.data.SDESC); setCpoTableenb(true); setEntrydataEnb(false);
  res.data.SDESC.map((item,i)=>{ if (item.year !== null) { setYear(item.year); } if (item.head_id !== null) { setHeadId(item.head_id); } }) }
  else{ setCpodata([]); showAlertMessage(res.data.SDESC,"warning") } }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
 }
const [buttonenb,setButtonEnb]=useState()
const getEntrydata = (e) => {formik.setFieldValue(
  "Indicators",
  (formik.values.Indicators || []).map(item => ({
    ...item,
    mer_sector_ind_value: ""
  }))
);
  if (!e.target.value) { let missingFields = []; if (!e.target.value) missingFields.push("Category"); const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`; showAlertMessage(errorMessage, "warning"); setCpoTableenb(false); setEntrydataEnb(false); return; }
 
  const params = { userId: username, year: formik.values.year, headId: e.target.value, periodicityId: formik.values.periodic_id||syn?.target?.value, }; fetchEntryData(params,formik.values.year);  };
const [isStatusFour, setIsStatusFour] = useState(false);
  const fetchEntryData = (params, selectedYear) => {
  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.getswakpimersectordata(params)
    .then((res) => {
      console.log(financialYear, "fin");
      console.log(selectedYear, "sel");
     
      
      if (res.data.SCODE === "01") {
  setEntrydataEnb(true);
  setCpoTableenb(false);
  setEntrydata(res.data.dataList);
  setworkFlow(res.data.getWorkFlow || []);

  // ✅ check if any item has status_id === 4
  const hasStatusFour = res.data.dataList.some(
    (item) => item.status_id === 4
  );
  setIsStatusFour(hasStatusFour);

  res.data.dataList.forEach((item, i) => {
    formik.setFieldValue(`Indicators[${i}].unit`, item.unit);
    formik.setFieldValue(`Indicators[${i}].mer_sector_id`, item.mer_sector_id);
    formik.setFieldValue(`Indicators[${i}].mer_sector_ind_id`, item.mer_sector_ind_id);
    formik.setFieldValue(`Indicators[${i}].mer_sector_ind_value`, item.mer_sector_ind_value);
  });
}
      else {
        setEntrydata([]);
        setEntrydataEnb(false);
        showAlertMessage(res.data.SDESC, "warning");
      }
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
};


const filteredData =searchText.length > 0 && Cpodata?.length ? Cpodata.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText.toLowerCase()) ); }) ); }) : Cpodata;
const validatevalue=()=>{ let val =false;  formik.values.Indicators.map((item, index) => { if(item.entry_value){ val= true; } }); return val; }
 
 



const SaveEntryData = (statusId,button) => {
let params = { type: button, 
    userId: username,districtId:  "", 
   sequenceId: sequenceId ||"0", periodicityId: Periodicid, 
   year: formik.values.year || 0, headId: formik.values.category || 0, swaKpiMerSectorSubRequestDto:[] };
  params.swaKpiMerSectorSubRequestDto = (formik.values.Indicators || [])
  .map((item) =>
    item && item.mer_sector_ind_value
      ? {
          merSectorId: item.mer_sector_id,
          merSectorIndId: item.mer_sector_ind_id,
          unit: item.unit||"0",
          statusId: statusId,
          merSectorIndValue: item.mer_sector_ind_value
        }
      : null
  )
  .filter(Boolean);
store.dispatch({ type: "SHOW_SPINNER" });
  KpiService.saveswakpimersectordata(params)
    .then((res) => {
      if (res.data.SCODE === "01") {
        showAlertMessage(res.data.SDESC, "success", () => {
          const fetchParams = { userId: username,
            districtId: formik.values.district_id,  
             year: formik.values.year, headId: formik.values.category || 0, 
             deptId: roleid === "8" ? formik.values.department_id : deptId, 
             periodicityId: formik.values.periodic_id||syn?.target?.value, };
          formik.values.Indicators.map((item,index)=>{
formik.setFieldValue(`Indicators[${index}].targetenb`, false); })
fetchEntryData(fetchParams,formik.values.year); });
      } else { showAlertMessage(res.data.SDESC, "warning"); }
    }) .catch((err) => { showAlertMessage("Failed to save data. Please try again.", "warning"); }) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); };
   
   
   
   

   
    const groupedData = Object.values(
  (EntryData || []).reduce((acc, item) => {
    if (!acc[item.mer_sector_id]) {
      acc[item.mer_sector_id] = {
        sectorName: item.mer_sector_name,
        indicators: []
      };
    }
    acc[item.mer_sector_id].indicators.push(item);
    return acc;
  }, {})
);

const validatefieldvalues=()=>{ let enb = false; {formik.values?.Indicators?.forEach((item, i) => { if(item.columns === 3 || item.columns === 4){if (!item.numerator && item.denominator) { showAlertMessage(`Please Enter Numerator!`, "warning"); enb = true; } if (item.numerator && !item.denominator) { showAlertMessage(`Please Enter Denominator!`, "warning"); enb = true; }} });} return enb; }
const submitData = () => { const val =validatevalue(); if(!val){ showAlertMessage("At least one entry value must be provided.","warning"); return; } let enable=validatefieldvalues(); if(enable){return;} 
let missingEntries = [];
formik.values.Indicators.forEach((item, index) => {
  if (item.targets_2025 !== null && item.targets_2025 !== "" && (item.entry_value === null || item.entry_value === "")) {
    missingEntries.push(`Indicator ${index + 1}`);
  } });
if (missingEntries.length > 0) { showAlertMessage( `Please enter values for all indicators which have targets assigned.`, "warning" ); return; }
setAddModal(true); formik.setFieldValue("remarks","") }

  return ( <> <Menubar />

 { (["40", "179", "137"].includes(deptId))?(
 <>
      <Container fluid style={{width:"95%"}} className='map-header '> <div className="sa-title"> <h2>Sector-wise Indicators <span> Entry   </span> </h2> </div> </Container>

      <Container fluid style={{width:"95%"}} className='mt-3 outer-page-content-container'> 
        <FormikProvider value={formik} > <Form onSubmit={formik.handleSubmit}>
            {/* <div className='mandal-container p-4'> */}
                
<div className="tabs-top">

<Nav variant="pills" className="tabs-row d-flex flex-wrap justify-content-start gap-1 mb-2 mt-4">
  {Object.entries(periodicityMap).map(([key, { label, value }]) => (
    <div
      key={key}
      className="flex-grow-1 flex-shrink-0"
      style={{ maxWidth: "120px" }}
    >
      <Nav.Item className="tab-boxes-small">
        <Nav.Link
          eventKey={value}
          onClick={() => {
            const syntheticEvent = {
              target: { name: "periodic_id", value },
            };
            setActivePeriodicity(value);
            YearData(syntheticEvent);
            formik.handleChange(syntheticEvent);
          }}
          active={activePeriodicity === value}
          className="text-center"
        >
          <p className="text-truncate text-center m-0">{label}</p>
        </Nav.Link>
      </Nav.Item>
    </div>
  ))}
</Nav>
                    
                    
                     </div>
   {/* </div> */}

          <Row>
  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select ' style={{marginLeft:"15px"}}> <label className="mb-1 fw-bold">Year</label> <Field className="form-control" component="select" name="year" controlId="formBasicEmail" onChange={(e) => { Categorydata(e); formik.handleChange(e) }} style={{ fontWeight: "bold" }} > <option value="">--Select--</option> {Yearlist} </Field> </Col>
<Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'> <label className="mb-1 fw-bold">Category</label> <Field className="form-control" component="select" name="category" controlId="formBasicEmail" style={{ fontWeight: "bold" }} onChange={(e) => { getEntrydata(e); formik.handleChange(e) }} > <option value="">--Select--</option> {Categorylist} </Field> </Col> 

    </Row> 


          {entrydataEnb &&
          <>
              <Row className="mt-2">
                <Col xxl={9} xl={9} lg={9} md={12} sm={12} xs={12} className="">
                        <Button variant="danger" size="sm" className="btn mx-2 mt-2 mb-1 pdf-btn"  style={{ float: "right", marginLeft: "3px" }} onClick={()=>generateentryPdf("my-table",formik.values,"Sector-wise Indicators Entry")}>PDF<MdOutlinePictureAsPdf /></Button> <Button  variant="success"  size="sm"   className="btn mx-2 mt-2 mb-1 excel-btn"  style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() =>  exportToentryExcel("my-table", formik.values,"Sector-wise Indicators Entry")}> <span style={{ color: "green" }}> Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </span> </Button>

            <div className="kp-indicatortable "> <div id="table-scroll" className="mt-5 mb-5" style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }} >

                        <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table">
                          <thead style={{ borderRadius: "10px 10px 0px 0px" }} >
                            <tr className="text-center"> <th  className="sticky-col sticky-sno">Sl.No.</th> <th className="sticky-col sticky-mandal" >INDICATOR</th> <th >UNIT</th>  <th > ACHIEVED VALUE</th> </tr>
                          </thead>
 <tbody>
  {!EntryData?.length ? (
    <tr>
      <td
        className="text-center"
        colSpan={formik.values.year === financialYear ? "6" : "5"}
      >
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    (() => {
      let runningIndex = -1; // ✅ continuous index

      return groupedData.map((sector, sIndex) => (
        <React.Fragment key={sIndex}>
          <tr>
            <td
              colSpan="6"
              style={{
                background: "rgb(255 219 154)",
                fontWeight: "bold",
              }}
            >
              {sector.sectorName}
            </td>
          </tr>

          {sector.indicators.map((detail, i) => {
            runningIndex++; // ✅ increment here

            return (
              <tr key={detail.mer_sector_ind_id}>
                <td
                  className="sticky-col sticky-sno"
                  style={{ textAlign: "center" }}
                >
                  {i + 1}
                </td>
                <td>{detail.mer_sector_ind_name}</td>
                <td>{detail.unit}</td>
                <td>
                  <Field
                    autoComplete="off"
                    className="form-control"
                    name={`Indicators[${runningIndex}].mer_sector_ind_value`} // ✅ fixed
                    type="text"
                    disabled={isStatusFour}
                    style={{ textAlign: "right" }}
                                        onKeyPress={(e) => isValidsix(e)}

                  />
                </td>
              </tr>
            );
          })}
        </React.Fragment>
      ));
    })()
  )}
</tbody>
 </table> </div> </div>


               </Col>
                  
                   </Row>
    

                 {!isStatusFour&&
                    <div className="bottom-buttons d-flex justify-content-center mb-5"> 
                         <Button variant="" size="sm" className="save-btn me-4" onClick={() => SaveEntryData(1,"save")} > Save <FaRegSave className="ms-1 s-icon" /> </Button>
                          <Button variant="" size="sm" className="next-btn me-4" onClick={() => SaveEntryData(4,"submit")}> Submit <IoReturnDownForward style={{ fontSize: "18px", marginLeft: "5px" }} /> </Button>


</div>}
          </>
                   }

     
          
                </Form> </FormikProvider> </Container><AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} /> 
     </>   
      )  :
        
        (<Container
  style={{
    width: "75%",
    minHeight: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: "100px",
  }}
  className="outer-page-content-container"
>
  <Row className="w-100 justify-content-center">
    <Col xxl={8} xl={8} lg={8} md={10} sm={10} xs={12}>
      <Alert
        severity="warning"
        icon={<FaExclamationTriangle className="blinking-icon" />}
        sx={{
          fontSize: "16px",
          padding: "40px 32px",
          borderRadius: "8px",
          backgroundColor: "#fff3cd",
          color: "#856404",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        Access not allowed for this login.
      </Alert>
    </Col>
  </Row>
</Container>
)}
</> );}


